<template>
<modal-dialog :modal-visible="visible"
	:title="title"
	confirm-button-text="Save"
	:submit-visible="!readonly"
	v-on:confirm="saveMaintenanceLog"
	v-on:closeModal="$emit('closeModal')">

	<field label="Work Type"
		col-class="col-md-4"
		:readonly="readonly"
		v-model="payload.type"
		:params="{type:'select',options: [
			'Inspection','Repair','Preventative Maintenance','Other'
		]}">
	</field>

	<field label="Date Done"
		:readonly="readonly"
		col-class="col-md-4"
		v-model="payload.date_done"
		:params="{type:'date'}">
	</field>

	<field label="Odometer/Hrs"
		:readonly="readonly"
		col-class="col-md-4"
		v-model="payload.mileage_or_time"
		:params="{type:'number',step:0.1,min:0}">
	</field>

	<field label="Done in-house?"
		:readonly="readonly"
		col-class="col-md-4"
		v-model="payload.in_house"
		:params="{type:'boolean'}"
		v-on:change="inHouseChange">
	</field>

	<field v-if="payload.in_house == 1"
		label="Done By"
		:readonly="readonly"
		col-class="col-md-4"
		v-model="payload.done_by_id"
		:params="{
			type:'select',
			options:userOptions(),
			selectedLabel: 'DoneBy' in record && record.DoneBy ? record.DoneBy.first_name+' '+record.DoneBy.last_name : false
		}">
	</field>

	<!-- Maintenance Vendor -->
	<field v-if="payload.in_house == 0"
		label="Maintenance Vendor"
		:readonly="readonly"
		col-class="col-md-4"
		v-model="payload.supplier_id"
		:params="{type:'select',options:optionify(suppliers,'name')}">
	</field>

	<!-- Work Done -->
	<field label="Work Done"
		col-class="stacked"
		:readonly="readonly"
		v-model="payload.work_done"
		:params="{type:'textarea', size:'xlg'}">
	</field>

	<!-- Update last service fields? -->
	<field :label="isCustomerAsset ? 'Update last service fields on Asset Record' : 'Update last service fields on Equipment Record'"
		col-class="col-auto"
		:readonly="readonly"
		v-model="updateLastServiceFields"
		:params="{type:'boolean'}">
	</field>

	<!-- Upload File -->
	<form-group :no-wrap="false"
		col-class="col-md-4"
		label="Upload a File"
		v-on:clickLabel="$emit('clickLabel')">

		<upload-field
			style="width:100%;height: 40px;margin-top:10px"
			:icons="['fa-plus','fa-file']"
			:multiple="true"
			accept="documents/images"
			target="LibraryUpload/save"
			style-type="box"
			v-on:uploaded="logFileUploaded($event)">
		</upload-field>

	</form-group>

	<!-- Uploaded Images -->
	<file-list-item
		v-for="file in mutatedLogFiles"
		:key="file.id"
		:id="file.id"
		:src="file.fullUrl"
		:thumb-src="file.thumbUrl"
		:no-edit-button="true"
		:filename="file.original_filename"
		:size-kb="file.file_size_kb"
		:date-uploaded="file.created_at"
		:uploaded-by="file.name"
		:other-buttons="[
			{
				icon: 'fa-share',
				text: 'Send to Files Tab',
				action: 'sendFileToFilesTab'
			}
		]"
		v-on:deleteFile="deleteFile(file)"
		v-on:sendFileToFilesTab="sendFileToFilesTab(file)">

	</file-list-item>

</modal-dialog>
</template>
<script type="text/javascript">

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FileListItem from "@/components/FileListItem"
import FormGroup from "@/components/FormGroup"
import UploadField from "@/components/UploadField"

export default {
	name: "EquipmentMaintenanceLogEditModal",
	components: {
		ModalDialog,
		Field,
		FileListItem,
		FormGroup,
		UploadField
	},
	props: ["record","visible","equipmentItem","readonly","isCustomerAsset"],
	data() {
		return {
			payload: {},
			updateLastServiceFields: true,
			logFiles: [],
			suppliers: [],
		}
	},
	watch: {
		record() {
			this.initPayload()

			if ("id" in this.record)
				this.fetchMaintenanceLogFiles(this.record.id)
		},
		visible() {
			if (this.visible)
				this.fetchSuppliers()
		}
	},
	computed: {
		title() {
			if ("id" in this.payload || "slug" in this.payload) {
				if (this.readonly)
					return "View Maintenance Log Entry"
				else
					return "Edit Maintenance Log Entry"
			}
			else
				return "New Maintenance Log Entry"
		},
		mutatedLogFiles() {
			let vm = this
			return this.logFiles.map(file => {
				if ('UpdatedBy' in file && file.UpdatedBy)
					file.name = file.UpdatedBy.first_name + ' ' + file.UpdatedBy.last_name

				file.fullUrl = window.apiRoot + "resources/files/" + vm.$store.sessionToken + "/" + file.filename

				return file
			})
		},
		resource() {
			if (this.isCustomerAsset) 
				return "AssetMaintenanceLog"
			else 
				return "EquipmentMaintenanceLog"
		}
	},
	methods: {
		initPayload() {
			let fields = ["id","slug","type","date_done","mileage_or_time","in_house","done_by_id","supplier_id","work_done"]

			fields.forEach(key => {
				if (this.record && key in this.record)
					this.payload[key] = this.record[key]
			})

			this.logFiles = []
		},
		inHouseChange(value) {
			if (value == 1 && this.$store.users.length == 0) 
				this.fetchUsers()

			this.$forceUpdate()
		},
		deleteFile(file) {
			let vm = this

			let payload = {
				id: file.id
			}

			// Delete the image, update our local image list & id list, then sync the log
			this.postData("LibraryUpload/delete",payload,true).then(response => {
				if (response.success) {
					vm.logFiles = vm.logFiles
							.filter(logFile => file.id != logFile.id)
					vm.syncMaintenanceLog()
				}
			})
		},
		syncMaintenanceLog() {
			// After an image is added/removed, update the maintenance log with the new image
			// id list WITHOUT performing a full save (ie updating equipment, closing modal, etc)
			let vm = this
			this.payload.UploadImage = this.logFiles.map(file => file.id)

			this.postData(this.resource + "/save",this.payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Maintenance log entry updated")
					vm.$forceUpdate()
				}
			})
		},
		logFileUploaded(response) {
			let vm = this

			let fileObj = {
				id: response.data.id,
				filename: response.uploadData.file_name,
				original_filename: response.uploadData.client_name,
				file_size_kb: response.uploadData.file_size,
				created_at: response.time
			}

			if ("thumb_filename" in response.uploadData) {
				fileObj.thumb_filename = response.uploadData.thumb_filename
				fileObj.thumbUrl = this.$store.apiRoot+'resources/images/'+this.$store.sessionToken+'/'+fileObj.thumb_filename
			}
			else
				fileObj.thumbUrl = false

			if ("image_height" in response.uploadData)
				fileObj.height = response.uploadData.image_height

			if ("image_width" in response.uploadData)
				fileObj.width = response.uploadData.image_width

			fileObj.fullUrl = this.$store.apiRoot+"resources/files/"+this.$store.sessionToken+"/"+fileObj.filename

			if (!("LibraryUpload" in this.payload) || !this.payload.LibraryUpload)
				this.payload.LibraryUpload = []

			this.payload.LibraryUpload.push(response.data.id)
			this.logFiles.push(fileObj)
		},
		saveMaintenanceLog() {
			let vm = this

			if (this.isCustomerAsset)
				this.payload.customer_asset_id = this.equipmentItem.id
			else
				this.payload.equipment_slug = this.$route.params.slug

			this.postData(this.resource + "/save",this.payload,true).then(response => {
				if (response.success) {
					if (vm.updateLastServiceFields) {
						let payload = {
							slug: vm.$route.params.slug,
							last_service_description: vm.payload.work_done,
							last_service_mileage_or_time: vm.payload.mileage_or_time,
							last_service_date: vm.payload.date_done
						}
						if (vm.isCustomerAsset) {
							vm.postData("CustomerAsset/save",payload,true)
						}
						else {
							vm.postData("Equipment/save",payload,true)
						}
					}
					vm.alertSaved("Maintenance log entry saved")
					vm.$emit('saved',response)
					vm.$emit('closeModal')
				}
			})
		},
		sendFileToFilesTab(file) {
			let vm = this

			let payload = {
				file_id: file.id,
				is_file: 1
			}

			let resource 
			if (this.isCustomerAsset) {
				payload.asset_id = this.equipmentItem.id	
				resource = "CustomerAssetFile"		
			}
			else {
				resource = "EquipmentFile"
				payload.equipment_id = this.equipmentItem.id
			}

			this.postData(this.resource + "/save",payload).then(response => {
				if (response.success)
					vm.alertSaved("File sent to files tab")
			})
		},
		fetchMaintenanceLogFiles(logID) {
			let vm = this

			let params = {
				fields: ["LibraryUpload"],
				include: [
					{
						// Attached images
						model: "LibraryUpload",
						include: [
							// Who uploaded those images?
							{ model: "User", fields: ["id","first_name","last_name"] }
						]
					}
				]
			}

			this.spinner(true)

			this.getJSON(this.resource + "/find/"+logID,params,true).then(response => {
				vm.spinner(false)
				if (response.success) {
					vm.logFiles = response.data.LibraryUpload
					vm.payload.LibraryUpload = response.data.LibraryUpload.map(file => file.id)
				}
			})
		},
		fetchSuppliers() {
			let vm = this

			let params = {
				filters: [
					["is_supplier",1]
				]
			}

			this.getJSON("Contact/get",params).then(response => {
				if (response.success)
					vm.suppliers = response.data
			})
		},
	},
	created() {
		if (this.record) {
			this.initPayload()

			if ("id" in this.record)
				this.fetchMaintenanceLogFiles(this.record.id)
		}
		if (this.visible)
			this.fetchSuppliers()
	}
}
</script>